import { render } from "./ScoringFinal.vue?vue&type=template&id=139da3e2"
import script from "./ScoringFinal.vue?vue&type=script&lang=js"
export * from "./ScoringFinal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__